import { RadioButtonChecked, RadioButtonUnchecked } from '@mui/icons-material';
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  SxProps,
  Typography,
} from '@mui/material';

export function ReservationOption(props: {
  title: string;
  description?: string;
  price: number | null;
  currencyCode: string;
  selected?: boolean;
  onClick?: () => void;
  disabled?: boolean;
  sx?: SxProps;
  message?: string;
  error?: boolean;
}) {
  return (
    <Card sx={props.sx}>
      <CardActionArea disabled={props.disabled} onClick={props.onClick}>
        <CardContent>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ flex: 1, mr: 2 }}>
              <Typography
                variant="h6"
                sx={{
                  color: props.disabled ? 'text.disabled' : 'inherit',
                }}
              >
                {props.title}
              </Typography>
              {props.description && (
                <Typography variant="body1" gutterBottom>
                  {props.description}
                </Typography>
              )}
            </Box>
            {props.price !== null && (
              <Typography
                variant="h4"
                component="span"
                sx={{
                  color: props.disabled ? 'text.disabled' : 'primary.main',
                  mr: 2,
                }}
              >
                {props.price.toLocaleString('tr-TR', {
                  style: 'currency',
                  currency: props.currencyCode,
                  maximumFractionDigits: 0,
                })}
              </Typography>
            )}
            {props.selected ? (
              <RadioButtonChecked color="primary" />
            ) : (
              <RadioButtonUnchecked
                color={props.disabled ? 'disabled' : 'inherit'}
              />
            )}
          </Box>
          {props.message && (
            <Typography
              component="div"
              variant="caption"
              sx={{
                color: props.error ? 'warning.main' : 'text.secondary',
              }}
            >
              {props.message}
            </Typography>
          )}
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
